import { BasisOptions } from './types';

export const basisQuestions: Record<string, any> = {
  basis: {
    id: 'basis',
    labelKey: 'applicationForm.BASIS.basis.label',
    options: [
      { labelKey: 'applicationForm.BASIS.advised.label', value: BasisOptions.ADVISED },
      { labelKey: 'applicationForm.BASIS.introducer.label', value: BasisOptions.INTRODUCER },
    ],
  },
};
